// extracted by css-extract-rspack-plugin
export default {"BoxHeader":"BoxHeader-module__BoxHeader__B4e4T","NestedBoxHeading":"BoxHeader-module__NestedBoxHeading__UL3wn"};